export const ActivityTypes = {
    SKIPPED: "skipped",
    FINISHED: "finished",
} as const;

export const ActivityStatuses = {
    INITIAL: "INITIAL",
    RUNNING: "RUNNING",
    COMPLETED: "COMPLETED",
    PROCESSED: "PROCESSED",
    SKIPPED: "SKIPPED",
    ENDING: "ENDING",
    ENDED: "ENDED",
} as const;

export const ActivityStatusToType: Record<string, string> = {
    [ActivityStatuses.PROCESSED]: ActivityTypes.FINISHED,
    [ActivityStatuses.COMPLETED]: ActivityTypes.FINISHED,
    [ActivityStatuses.SKIPPED]: ActivityTypes.SKIPPED,
};

export const FormTypes = {
    PURCHASE_INVOICE: "purchase_invoice",
    SALES_INVOICE: "sales_invoice",
    PETTY_CASH_DISBURSTMENT: "petty_cash_disburstment",
    PETTY_CASH_INCOME: "petty_cash_income",
    CATEGORIZE: "categorize",
} as const;

export type FormType = (typeof FormTypes)[keyof typeof FormTypes];

export const CategoryToFormType: Record<string, FormType> = {
    purchase: FormTypes.PURCHASE_INVOICE,
    sales: FormTypes.SALES_INVOICE,
};
